var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSampleCollectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52601",
    "data-name": "Group 52601",
    transform: "translate(-158 -2672.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18675",
    "data-name": "Rectangle 18675",
    transform: "translate(158 2672.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_24_",
    "data-name": "svgexport-7 (24)",
    transform: "translate(-42.15 2679.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52557",
    "data-name": "Group 52557",
    transform: "translate(221.7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52556",
    "data-name": "Group 52556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52555",
    "data-name": "Group 52555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52554",
    "data-name": "Group 52554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91076",
    "data-name": "Path 91076",
    d: "M1149.48,43.029a1.327,1.327,0,0,1,.2.99l-.192.957-2.587-.517.192-.957a1.325,1.325,0,0,1,1.552-1.039A1.309,1.309,0,0,1,1149.48,43.029Z",
    transform: "translate(-1112.707 -41.129)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91077",
    "data-name": "Path 91077",
    d: "M1103.855,117.868l-.72,3.6-4.335-.872.721-3.6Z",
    transform: "translate(-1066.384 -112.935)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91078",
    "data-name": "Path 91078",
    d: "M248.414,44.527l1.057,3.537-2.886.861-2.886.861-1.057-3.537a3.073,3.073,0,0,1,1.992-3.858,2.948,2.948,0,0,1,2.3.262A3.2,3.2,0,0,1,248.414,44.527Z",
    transform: "translate(-241.736 -40.964)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91079",
    "data-name": "Path 91079",
    d: "M284.439,250.2l3.7,12.366h-2.661L282,250.928Z",
    transform: "translate(-279.771 -241.212)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91080",
    "data-name": "Path 91080",
    d: "M374.639,223.2l3.991,13.364H375.97l-3.77-12.632Z",
    transform: "translate(-366.638 -215.21)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91081",
    "data-name": "Path 91081",
    d: "M659.049,25.767v2.591H649V7h10.049V9.868h-6.438a.466.466,0,1,0,0,.931h6.442v2.816h-3.98a.466.466,0,0,0,0,.931h3.98V17.37h-6.442a.466.466,0,1,0,0,.931h6.442v2.816h-3.98a.466.466,0,0,0,0,.931h3.98v2.787h-6.442a.466.466,0,1,0,0,.931Z",
    transform: "translate(-633.208 -7)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91082",
    "data-name": "Path 91082",
    d: "M1031.5,239.972l-2.384,11.9H1024.6l2.557-12.776Z",
    transform: "translate(-994.926 -230.522)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91083",
    "data-name": "Path 91083",
    d: "M262.438,610v4.221H221.7V610Z",
    transform: "translate(-221.7 -587.714)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91084",
    "data-name": "Path 91084",
    d: "M299.7,749.4h34.973v5.85H299.7Z",
    transform: "translate(-296.817 -721.963)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91085",
    "data-name": "Path 91085",
    d: "M299.7,932.8h34.973v22.552H299.7Z",
    transform: "translate(-296.817 -898.585)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91086",
    "data-name": "Path 91086",
    d: "M1239.241,243.772a.469.469,0,0,1,.067.351l-1.545,7.558a.466.466,0,0,1-.913-.185l1.453-7.1-2.4-.484.092-.458.093-.455,2.86.577A.461.461,0,0,1,1239.241,243.772Z",
    transform: "translate(-1198.418 -234.278)",
    fill: "#93a750"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleCollectionIcon);
export default __webpack_public_path__ + "static/media/SampleCollectionIcon.ddb5150701cb59033dfcba787329a8d8.svg";
export { ForwardRef as ReactComponent };